import { ShimmerBlock } from "../../../../utils/SkeletonUtils";

const rowBase =
  "flex min-w-0 items-center border-b border-slate-200 last:border-b-0 gap-2 sm:gap-3 px-2 sm:px-3 py-2.5 animate-pulse";

type RowsProp = { rows?: number };

/** Fills the tbody placeholder cell in `Table` (single `td` with colspan). */
export function ExitPendingApprovalsTableSkeleton({ rows = 8 }: RowsProp) {
  return (
    <div
      className="w-full min-w-0"
      role="status"
      aria-label="Loading exit approvals"
    >
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={rowBase}>
          <div className="min-w-0 flex-1 space-y-1.5 sm:min-w-[12rem]">
            <ShimmerBlock className="h-4 w-[min(200px,100%)]" />
            <ShimmerBlock className="h-3 w-24" />
          </div>
          <div className="w-[5.5rem] shrink-0 sm:w-28">
            <ShimmerBlock className="h-6 w-20 rounded" />
          </div>
          <div className="w-32 min-w-0 shrink-0 hidden md:block space-y-1">
            <ShimmerBlock className="h-3 w-full" />
            <ShimmerBlock className="h-3 w-[85%]" />
          </div>
          <div className="w-20 shrink-0">
            <ShimmerBlock className="h-4 w-16" />
          </div>
          <div className="w-24 shrink-0 hidden sm:block">
            <ShimmerBlock className="h-4 w-20" />
          </div>
          <div className="w-28 shrink-0 flex justify-center gap-1.5">
            <ShimmerBlock className="h-8 w-8 rounded-md" />
            <ShimmerBlock className="h-8 w-8 rounded-md" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ExitSetupInterviewTableSkeleton({
  rows = 5,
  hasActions = false,
}: RowsProp & { hasActions?: boolean }) {
  return (
    <div
      className="w-full min-w-0"
      role="status"
      aria-label="Loading interview question sets"
    >
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={rowBase}>
          <div className="min-w-0 flex-1">
            <ShimmerBlock className="h-4 w-[min(220px,100%)]" />
          </div>
          <div className="w-20 shrink-0 text-right">
            <ShimmerBlock className="h-4 w-8 inline-block" />
          </div>
          {hasActions ? (
            <div className="w-24 shrink-0 flex justify-center gap-1.5">
              <ShimmerBlock className="h-8 w-8 rounded-md" />
              <ShimmerBlock className="h-8 w-8 rounded-md" />
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}

export function ExitSetupChecklistTemplatesTableSkeleton({
  rows = 5,
  hasActions = false,
}: RowsProp & { hasActions?: boolean }) {
  return (
    <div
      className="w-full min-w-0"
      role="status"
      aria-label="Loading checklist templates"
    >
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={rowBase}>
          <div className="min-w-0 flex-1">
            <ShimmerBlock className="h-4 w-[min(180px,100%)]" />
          </div>
          <div className="w-24 shrink-0">
            <ShimmerBlock className="h-4 w-20" />
          </div>
          <div className="w-16 shrink-0 text-right">
            <ShimmerBlock className="h-4 w-6 inline-block" />
          </div>
          {hasActions ? (
            <div className="w-24 shrink-0 flex justify-center gap-1.5">
              <ShimmerBlock className="h-8 w-8 rounded-md" />
              <ShimmerBlock className="h-8 w-8 rounded-md" />
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
